import type { NextPage, GetStaticProps, InferGetStaticPropsType } from "next";
import { useRouter } from "next/router";

import { FooterData, getFooterData } from "data/footer";
import { StorefrontData } from "data/storefront";

import { getStorefronts, getStorefrontWithProducts } from "~/api/storefrontApi";
import { Storefront } from "~/components/storefront";
import { getPathForProduct } from "~/util/stringUtils";

interface StaticProps {
  storefrontData: StorefrontData;
  footerData: FooterData;
}

const StorefrontSSG: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  storefrontData,
  footerData,
}) => {
  const router = useRouter();
  if (router.isFallback) {
    return <div>Loading...</div>;
  }

  return <Storefront storefrontData={storefrontData} footerData={footerData} />;
};

export async function getStaticPaths() {
  let storefronts = await getStorefronts();

  console.log("got the following storefronts from API: ", storefronts);

  storefronts = storefronts.filter((storefrontObject: StorefrontData) => {
    return storefrontObject.products?.length > 1;
  });

  const paths = storefronts.map((storefrontObject: StorefrontData) => {
    return {
      params: {
        storefrontSlug: storefrontObject.slug,
      },
    };
  });

  return {
    paths: paths,
    fallback: true,
  };
}

export const getStaticProps: ({
  params,
}: {
  params: any;
}) => Promise<{ redirect: { destination: string } } | { props: StaticProps }> = async ({
  params,
}) => {
  // go fetch API, get data, pass down as props
  console.log("fetching storefront data");

  const slug = params.storefrontSlug;
  console.log("slug is ", slug);

  const storefrontData = await getStorefrontWithProducts(slug);

  console.log("storefront data is ", storefrontData);
  if (!storefrontData || !storefrontData.slug) {
    if (slug == "settings") {
      return {
        redirect: {
          destination: `${process.env.ROUTING_FALLBACK_URL}/settings`,
        },
      };
    }
    if (slug == "history") {
      return {
        redirect: {
          destination: `${process.env.ROUTING_FALLBACK_URL}/history`,
        },
      };
    }
    if (slug == "profile") {
      return {
        redirect: {
          destination: `${process.env.ROUTING_FALLBACK_URL}/profile`,
        },
      };
    }
    if (slug == "andrew-old-class") {
      return {
        redirect: {
          destination: `${process.env.ROUTING_FALLBACK_URL}/andrew-huang-music/January-6-2020/classroom`,
        },
      };
    }

    // Use this if we want to redirect to old app
    // return {
    //   redirect: {
    //     source: "/:path*",
    //     destination: `${process.env.ROUTING_FALLBACK_URL}/:path*`,
    //   },
    // };

    // If not recognized, just redirect to homepage "/"
    return {
      redirect: {
        destination: "/",
      },
    };
  }

  // If there is only one class, redirect directly to that class.
  if (storefrontData.products && storefrontData.products.length == 1) {
    return {
      redirect: {
        destination: getPathForProduct(storefrontData.products[0]),
      },
    };
  }

  return {
    props: {
      storefrontData: storefrontData,
      footerData: getFooterData(),
    },
  };
};

export default StorefrontSSG;
